
import CompanyContactPicker from '@/components/CompanyContactPicker/CompanyContactPicker.vue'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import UserPicker from '@/components/UserPicker/UserPicker.vue'
import ViewModel from '@/models/ViewModel'
import { currencyMask } from '@/models/interface/Masks'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { DaysOfWeek, OpportunitySource, ProductsFull } from '@/models/interface/Common'
import Opportunity from '@/models/Opportunity'
import MediaPlanPicker from '@/pages/Expenses/components/MediaPlanPicker.vue'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import SelectOption from '@/models/interface/SelectOption'
import Company from '@/models/Company'
import Inventory from '@/models/Inventory'
import SalesRepShares from './SalesRepShares.vue'

@Component({
  components: {
    CompanyContactPicker,
    CompanyPicker,
    FormInput,
    UserPicker,
    SelectPicker,
    DatePicker,
    MediaPlanPicker,
    CheckboxInput,
    SalesRepShares,
  },
})
export default class OpportunityForm extends ViewModel {
  @Prop()
  public value!: any

  public loading: boolean = true

  @Prop({ default: false })
  public disabled!: boolean

  public local_value: Opportunity = new Opportunity()

  public lost_categories: any = Opportunity.option_list.lost_categories

  public lead_sources: any = Opportunity.option_list.lead_sources

  public mrgs: any = Opportunity.option_list.mrgs

  public force_new_business_options = [
    {
      name: 'Auto',
      value: 'auto',
    },
    {
      name: 'Yes',
      value: 'yes',
    },
    {
      name: 'No',
      value: 'no',
    },
  ]

  public opportunity_reason: boolean = false

  @Watch('local_value', { deep: true })
  public onLocalValueChange(val: Opportunity) {
    this.$emit('input', val)
  }

  @Watch('local_value.types')
  public onChangeType(val: any, oldVal: any) {
    if (oldVal && oldVal.includes('home') && !val.includes('home')) {
      this.local_value.teams = []
    }
  }

  @Watch('local_value.advertiser_id')
  public onChangeAdvertiser() {
    const { query } = this.$route
    if (
      !this.local_value.advertiser_id
      || this.id
      || (query.from && typeof query.from === 'string')
    ) {
      return
    }

    Company.find(this.local_value.advertiser_id).then(advertiser => {
      if (!advertiser) {
        return
      }
      this.local_value.advertiser = advertiser
      if (!this.id) {
        this.local_value.is_political = advertiser.is_political
      }
    })
  }

  public get masks() {
    return {
      currency: currencyMask,
    }
  }

  public team_options: any = []

  public get options() {
    return {
      days_of_week: DaysOfWeek,
      opportunities: {
        status: Opportunity.opportunity_status,
        types: ProductsFull,
        sources: OpportunitySource,
      },
      teams: this.team_options,
    }
  }

  public created() {
    if (this.value) this.local_value = this.value
  }

  public mounted() {
    if (this.value) this.local_value = this.value
    this.loading = false
    if (!this.local_value.id || !this.local_value.id.length) {
      this.local_value.created_by_id = this.user.id
    }

    this.loadReportNames()
  }

  public askReason() {
    this.opportunity_reason = true
  }

  public new_account_options: SelectOption[] = Opportunity.force_new_account_options

  public async loadReportNames() {
    Inventory.loadReportNameOptions({ type: 'home' }).then(res => {
      this.team_options = res
    })
    //
  }
}
